import { CommonResponseModel, driverIdReq, PlantIdReq} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class LocationService extends CommonAxiosService {
    private LocationController = "/locations";

    async createLocation(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.LocationController + "/createLocation", payload)
    }

    async getAllLocation(req?:driverIdReq):Promise<CommonResponseModel> {
        return this.axiosPostCall(this.LocationController + "/getAllLocations",req)
    }

    async getActiveAllLocation(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.LocationController + "/getAllActiveLocations")
    }
    async updateLocation(dto: any): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.LocationController + '/updateLocation', dto)
    }

    async activateOrDeactivateLocation(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.LocationController + "/activateOrDeactivateLocation", payload)
    }

    async getActiveAllLocationByPlant(req:PlantIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.LocationController + "/getActiveAllLocationByPlant",req)
    }

}